import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  Heading,
  DrawerBody,
  Box,
  Flex,
} from '@mezzoforte/forge';
import dynamic from 'next/dynamic';
import { MutableRefObject, useEffect, useRef } from 'react';
import OverlayBadge from '@/components/ImageCarousel/OverlayBadge';
import { CarouselItem } from '@/components/ImageCarousel/CarouselItem';
import { Picture } from '@/components/Image/Picture';

const VideoSlide = dynamic(() => import('./VideoSlide'), { ssr: false });

function Items({
  items,
  scrollToIndex,
  scrollRef,
}: {
  items: CarouselItem[];
  scrollToIndex: number;
  scrollRef: MutableRefObject<HTMLElement | null>;
}) {
  useEffect(() => {
    const element = document.getElementById(`media-${scrollToIndex}`);
    if (element) {
      scrollRef.current?.scrollTo({
        top: element.offsetTop - 80,
      });
    }
  }, [scrollRef, scrollToIndex]);

  return (
    <Box>
      {items.map((item, index) => (
        <Flex
          key={item.key}
          id={`media-${index}`}
          mb={2}
          overflow="hidden"
          position="relative"
          justifyContent="center"
        >
          {item.videoId === null ? (
            <Box>
              <OverlayBadge
                position="absolute"
                mt="14px"
                ml="10px"
              >
                {index + 1} / {items.length}
              </OverlayBadge>
              <Picture
                formats={item.drawer}
                width={0}
                height={0}
                style={{
                  position: 'static',
                  height: 'auto',
                  width: 'auto',
                  maxHeight: '90vh',
                }}
              />
            </Box>
          ) : (
            <VideoSlide videoId={item.videoId} />
          )}
        </Flex>
      ))}
    </Box>
  );
}

interface ImageDrawerProps {
  items: CarouselItem[];
  isOpen: boolean;
  onClose: () => void;
  scrollToIndex: number;
}

export default function ImageDrawer({ items, isOpen, onClose, scrollToIndex }: ImageDrawerProps) {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  return (
    <Drawer
      allowPinchZoom
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      placement="bottom"
    >
      <DrawerOverlay />
      <DrawerContent height="100%">
        <DrawerCloseButton
          onClick={onClose}
          aria-label="Sulje"
          position="absolute"
        />
        <DrawerHeader p={3}>
          <Heading
            variant="h3"
            as="h3"
          >
            Kohteen kuvat
          </Heading>
        </DrawerHeader>
        <DrawerBody
          px={3}
          ref={scrollRef}
        >
          <Items
            items={items}
            scrollToIndex={scrollToIndex}
            scrollRef={scrollRef}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
